function buyNow(type = 'abBuyNow') {
  let id = document.getElementById('buyNow').value;
  let items = []
  items.push({
    'id': id,
    'quantity': 1,
  })
  if($('.abGoodsBundleSales .actived').length) {
    $('.abGoodsBundleSales .actived').each((ind, ele) => {
      items.push({
        'id': $(ele).data("product-id"),
        'quantity': 1,
      })
    })
  }
  let formData = {
    'items': [...items]
  };
  // 使用 AJAX 将商品添加到购物车
  if(type == "abBuyNow") {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((data) => {
        // 添加成功后，跳转到结算页面
        window.location.href = '/checkout';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  else if (type == "abAddToCart") {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(res => {
      window.location.href = '/cart';
    })
  }
}

// 切换颜色时，设置第一个版本为默认购买 id
function setBuyVariantId() {
  // 找颜色索引
  for (let i in productInfo.options) {
    if (productInfo.options[i] == 'Color') {
      colorOptIndex = i;
      break;
    }
  }

  // 设置颜色默认选择
  if (selectedColor == null) {
    selectedColor = productInfo.variants[0].options[colorOptIndex];
  }

  // 找版本索引
  for (let i in productInfo.options) {
    if (productInfo.options[i] == 'Version') {
      verOptIndex = i;
      break;
    }
  }
  if (selectedColor == null) {
    // 设置版本默认选中
    selectedVersion = productInfo.variants[0].options[verOptIndex];
  }

  // 找购买 id
  let id = null;
  if (productInfo.options.length == 1) {
    switch (productInfo.options[0]) {
      case 'Color':
        for (let item of productInfo.variants) {
          if (item.options[0] == selectedColor) {
            id = item.id;
          }
        }
        break;
      case 'Version':
        for (let item of productInfo.variants) {
          if (item.options[0] == selectedVersion) {
            id = item.id;
          }
        }
        break;
    }
  } else if (productInfo.options.length == 2) {
    // console.log("colorOptIndex:", colorOptIndex, "|", "selectedColor:", selectedColor)
    // console.log("verOptIndex:", verOptIndex, "|", "selectedVersion:", selectedVersion)

    for (let item of productInfo.variants) {
      if (item.options[colorOptIndex] == selectedColor) {
        if (!selectedVersion) {
          id = item.id;
          //console.log("找到了-shouci ", item)
          break;
        } else if (item.options[verOptIndex] == selectedVersion) {
          id = item.id;
          //console.log("找到了", item)

          break;
        }
      }
    }
  }
  if (id != null) {
    document.getElementById('addToCart').value = id;
    document.getElementById('addToCart2').value = id;
    document.getElementById('buyNow').value = id;
    document.getElementById('buyNow2').value = id;
  }
  return id;
}

const CURRENCY_SYMBOL = getCurrencySymbol(window.Shopify.currency.active)
// 切换规格时更新价格
function updatePrice(variantId) {
  let price = document.getElementById('abGoodsPrice');
  let payAmount = document.querySelector('.abPrice1');
  let priceCompare = document.querySelector('.abGoodsComparePrice');

  // 找出目标 variantId 的销售价格、市场价格
  let variantPrice, variantComparePrice;
  for (let item of productInfo.variants) {
    if (item.id == variantId) {
      variantPrice = item.price;
      variantComparePrice = item.compare_at_price || 0;
      break;
    }
  }
  $('.apProductInfo .apProductInfoRight .abGoodsBundleSales .actived').each(function(index, ele) {
    let price = $(ele).data('price')
    let compareAtPrice = $(ele).data('data-compare-at-price') || $(ele).data('price')
    // console.log('price',price,compareAtPrice)
    variantPrice += Number(price)
    variantComparePrice += Number(compareAtPrice)
  });
  // console.log('11111',formatMoney(variantPrice))
  price.innerText = formatMoney(variantPrice);
  payAmount.innerText = formatMoney(variantPrice);

  // 是否设置了比较价格
  if (variantComparePrice > variantPrice) {
    priceCompare.innerText = formatMoney(variantComparePrice);
    let saveAmount = formatMoney(variantComparePrice - variantPrice);
    // abGoodsPriceOnAlbum.innerText = 'Save ' + saveAmount;
    if (variantComparePrice - variantPrice > 0) {
      // abGoodsPriceOnAlbum.style.display = 'block';
      document.querySelector('.abPrice2').innerText = 'Save ' + saveAmount;
    }
  } else {
    if (priceCompare) priceCompare.innerText = '';
    // abGoodsPriceOnAlbum.style.display = 'none';
    document.querySelector('.abPrice2').innerText = '';
  }
}

function getCurrencySymbol(currencyCode) {
  let res = (0).toLocaleString(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).replace(/\d/g, '').trim();
  return res
}
// 选择规格
function selectVersion(element, hasDesc2, ver, verImgSrc) {
  const abGoodsDesc2 = document.getElementById('abGoodsDesc2');
  selectedVersion = ver;
  let id = setBuyVariantId();
  updatePrice(id);
  for (let item of allGoodsVersionItem) {
    item.style.borderColor = '#D9D9D9';
  }
  $(element).addClass('actived').siblings('.actived').removeClass('actived');
  element.style.borderColor = activeVersionBorderColor;
  let nodes = abGoodsDesc2.querySelectorAll('li');
  if (hasDesc2 == 'true') {
    nodes.forEach((node) => {
      node.style.textDecoration = 'none';
    });
  } else {
    nodes.forEach((node) => {
      node.style.textDecoration = 'line-through';
    });
  }

  // 切换图
  let targetImgFileName = verImgSrc.split('/')[1];
  for (let key in productInfo.images) {
    let arr = productInfo.images[key].split('?');
    let arr2 = arr[0].split('/');
    let fileName = arr2[arr2.length - 1];
    if (fileName == targetImgFileName) {
      goodsProductSwiper1.slideTo(parseInt(key));
      productImgCurrentPage.innerText = parseInt(key) + 1; // 更新分页器索引
      productImageIndex = parseInt(key) + 1; // 更新分页器索引
      return;
    }
  }
}

function formatMoney(cents) {
  const dollars = cents / 100;
  // let res =  new Intl.NumberFormat(Shopify.locale, {
  //   style: 'currency',
  //   currency: window.Shopify.currency.active,
  // }).format(dollars);
  return `${getCurrencySymbol(window.Shopify.currency.active)}${dollars.toFixed(2)}`
}

function copyCode(txt) {
  // 创建一个临时的文本区域来复制内容
  var tempInput = document.createElement('textarea');
  tempInput.value = txt;
  document.body.appendChild(tempInput);
  // 选择文本并复制
  tempInput.select();
  document.execCommand('copy');
  // 移除临时文本区域
  document.body.removeChild(tempInput);
}

// 切换颜色。同时更新价格显示，以及带颜色的产品图
function switchColor(color) {
  selectedColor = color;

  // 切换版本组
  document.querySelectorAll('.abGoodsParts').forEach((ele) => {
    ele.style.display = 'none';
  });
  document.getElementById(color + 'VerGroup').style.display = 'flex';

  // 切换到 products tab
  let element = document.getElementById('productTab');
  switchGoodsTab(element, 1);

  // 切换颜色图
  for (let item of productInfo.variants) {
    if (item['option' + (parseInt(colorOptIndex) + 1)] == color) {
      const colorImg = item.featured_image.src;
      for (let key in productInfo.images) {
        if (productInfo.images[key] == colorImg) {
          goodsProductSwiper1[0].slideTo(parseInt(key)); // 切换图片
          productImgCurrentPage.innerText = parseInt(key) + 1; // 更新分页器索引
          break;
        }
      }
      break;
    }
  }

  // 重置已选择的版本，因为在另一个颜色中不一有此版本规格
  try {
    selectedVersion = null;
    for (let item of allGoodsVersionItem) {
      item.style.borderColor = '#D9D9D9';
    }
    document.querySelector('#' + color + 'VerGroup' + ' .abGoodsPartsItem').style.borderColor = '#777';

    // 设置默认选择版本
    const id = setBuyVariantId();
    updatePrice(id);
  } catch (e) {
    // 没有规格
  }
}

// 播放视频或渲染 3d
function playVideoOr3d() {
  if (!isMobile()) {
    for (item of medias) {
      if (item.media_type == 'model') {
        render3d(item);
        return;
      }
    }
  }
  for (item of medias) {
    if (item.media_type == 'video') {
      //console.log(item)
      video_url = 'https:' + item.sources[3].url;
      playVideo(video_url);
    }
  }
}

// 渲染 3d
function render3d(item) {
  let modelViewer = document.getElementById('glb3d');
  //console.log(item)
  let glbUrl = 'https:' + item.sources[1].url;
  let previewImage = 'https:' + item.preview_image.src;
  modelViewer.setAttribute('src', glbUrl);
  modelViewer.setAttribute('poster', previewImage);
  modelViewer.style.display = 'block';
}

// 播放视频
function playVideo(videoUrl) {
  var video = document.getElementById('goodsVideo');
  video.style.display = 'block';
  if (Hls.isSupported()) {
    var hls = new Hls();
    hls.loadSource(videoUrl);
    hls.attachMedia(video);
    hls.on(Hls.Events.MANIFEST_PARSED, function () {
      video.play();
    });
  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = videoUrl;
    video.addEventListener('loadedmetadata', function () {
      video.play();
    });
  }
}

// 切换 tab
function switchGoodsTab(ele, index) {
  // 处理 tab 选中状态
  const container = document.querySelector('.abGoodsAlbumTabs');
  const pTags = container.querySelectorAll(':scope > p');
  pTags.forEach((p) => {
    p.classList.remove('abGoodsAlbumTabActive');
  });
  ele.classList.add('abGoodsAlbumTabActive');

  // 切换容器
  for (let i = 1; i <= 3; i++) {
    document.getElementById('tab' + i).style.display = 'none';
  }
  document.getElementById('tab' + index).style.display = 'flex';
  currentTabIndex = index;

  if (currentTabIndex == 3) {
    if (!isMobile()) {
      leftButton1.style.display = 'none';
      rightButton1.style.display = 'none';
      leftButton2.style.display = 'none';
      rightButton2.style.display = 'none';
    }
    abGoodsScenePage.style.display = 'none';
    abGoodsAlbumsPage.style.display = 'none';
    playVideoOr3d();
  } else {
    if (!isMobile()) {
      if (currentTabIndex == 1) {
        leftButton1.style.display = 'flex';
        rightButton1.style.display = 'flex';
        leftButton2.style.display = 'none';
        rightButton2.style.display = 'none';
      } else if (currentTabIndex == 2) {
        leftButton2.style.display = 'flex';
        rightButton2.style.display = 'flex';
        leftButton1.style.display = 'none';
        rightButton1.style.display = 'none';
      }
    }
  }

  // 切换页码
  if (currentTabIndex == 1) {
    abGoodsScenePage.style.display = 'none';
    abGoodsAlbumsPage.style.display = 'block';
  } else if (currentTabIndex == 2) {
    abGoodsAlbumsPage.style.display = 'none';
    abGoodsScenePage.style.display = 'block';
  }

  // 价格只在产品相册上显示
  // if (currentTabIndex == 1) {
  //   if (abGoodsPriceOnAlbum) abGoodsPriceOnAlbum.style.display = 'block';
  // } else {
  //   if (abGoodsPriceOnAlbum) abGoodsPriceOnAlbum.style.display = 'none';
  // }
}

function slideLeft() {
  if (currentTabIndex == 1) {
    // products images
    if (productImageIndex == 1) {
      productImgCurrentPage.innerText = productImgTotal;
      productImageIndex = productImgTotal;
      return;
    }
    productImageIndex--;
    productImgCurrentPage.innerText = productImageIndex;
  } else if (currentTabIndex == 2) {
    // scene images
    if (sceneImageIndex == 1) {
      productImgCurrentPage.innerText = sceneImgTotal;
      productImageIndex = sceneImgTotal;
      return;
    }
    sceneImageIndex--;
    sceneImgCurrentPage.innerText = sceneImageIndex;
  }
}

function slideRight() {
  if (currentTabIndex == 1) {
    // debugger;
    // if (productImageIndex == productImgTotal) {
    //   productImgCurrentPage.innerText = 1;
    //   productImageIndex = 1;
    //   return;
    // }
    if (productImageIndex === 0) {
      productImageIndex = 1;
    } else {
      productImageIndex++;
    }
    productImgCurrentPage.innerText = productImageIndex;
  } else if (currentTabIndex == 2) {
    if (sceneImageIndex == sceneImgTotal) {
      sceneImgCurrentPage.innerText = 1;
      sceneImageIndex = 1;
      return;
    }
    sceneImageIndex++;
    sceneImgCurrentPage.innerText = sceneImageIndex;
  }
}
